import React, { useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Column, Control, Label } from "rbx";
import FilterButtons from "../../../components/FilterButtons";

import { DateInput, SystemCodeSelect } from "../../../components/inputs";

const INITIAL_FILTER_STATE = {};

const VehicleInspectionFilter = ({ filters, onFilter, onClose }) => {
  const [inputs, setInputs] = useState({ ...filters });

  const handleChange = e => {
    setInputs({ ...inputs, [e.target.name]: parseInt(e.target.value) });
  };

  const handleDateChange = e => {
    const updates = { ...inputs };
    const { value } = e.target;
    updates[e.target.name] = value;
    setInputs({ ...updates });
  };

  const handleClose = () => onClose(onFilter(inputs));
  const handleCancel = () => onClose();
  const handleReset = () => onClose(onFilter({ ...INITIAL_FILTER_STATE }));

  return (
    <div className="inspection-modal-container">
      <Column.Group>
        <Column>
          <Control expanded>
            <SystemCodeSelect
              icon="globe"
              label="Inspection Type"
              lookup={{ Category: "Fleet", Code: "VehicleInspectionType" }}
              name="InspectionTypeRecIdRef"
              showHelp={false}
              value={inputs.InspectionTypeRecIdRef}
              onChange={handleChange}
            />
          </Control>
        </Column>
        <Column>
          <Control>
            <Label>Start Date</Label>
            <DateInput
              name="InspectionDate_gte"
              value={
                inputs.InspectionDate_gte
                  ? moment(inputs.InspectionDate_gte).format("YYYY-MM-DD")
                  : ""
              }
              onChange={handleDateChange}
            />
          </Control>
        </Column>
        <Column>
          <Control>
            <Label>End Date</Label>
            <DateInput
              name="InspectionDate_lte"
              value={
                inputs.InspectionDate_lte
                  ? moment(inputs.InspectionDate_lte).format("YYYY-MM-DD")
                  : ""
              }
              onChange={handleDateChange}
            />
          </Control>
        </Column>
      </Column.Group>
      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </div>
  );
};

VehicleInspectionFilter.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func
};
export default VehicleInspectionFilter;
